import { useCallback, useContext, useEffect, useRef } from 'react';

import { FormRuntimeContext } from '../../form-renderer/FormRuntimeContext';

/* Long enough for the visitor to see their pick highlighted, and for the
   hidden input to re-render with the new value before the step is collected. */
const ADVANCE_DELAY_MS = 350;

export const useAutoAdvance = (enabled: boolean) => {
  const { advanceStep } = useContext(FormRuntimeContext);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  return useCallback(() => {
    if (!enabled || !advanceStep) return;
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(advanceStep, ADVANCE_DELAY_MS);
  }, [enabled, advanceStep]);
};
